// extracted by mini-css-extract-plugin
export var arrow = "_2d-6";
export var changeItem = "_2d-3";
export var changesHeader = "_2d-1";
export var changesList = "_2d-2";
export var container = "_2d-0";
export var pathLabel = "_2d-4";
export var value = "_2d-7";
export var valuesContainer = "_2d-5";